// Unfortunately there are no typings for such an old version of TimeMe.js
// @ts-ignore
import TimeMe from 'timeme.js';
export const timeMeInstrumentationService = {
  init(options, onUserLeave) {
    let redirectTimeout;
    TimeMe.initialize({
      idleTimeoutInSeconds: options.idleTimeout
    });
    TimeMe.callWhenUserLeaves(() => {
      redirectTimeout = setTimeout(onUserLeave, options.afterIDLETimeoutInMilliseconds);
    });
    TimeMe.callWhenUserReturns(() => {
      clearTimeout(redirectTimeout);
    });
  }
};
//# sourceMappingURL=timeme-instrumentation-service.js.map